export const AppState = {
  PageNavigation: 'pageNavigation',
  DataLayer: 'dataLayer',
  EnabledFlippers: 'enabledFlippers',
  Flippers: 'flippers',
  Device: 'device',
  TriggeredPageReady: 'triggeredPageReady',
  HydrateComplete: 'hydrateComplete',
  isBot: 'isBot',
  NavigationState: 'navigationState',
  PageId: 'pageId'
};
export const NavigationState = {
  Complete: 'complete',
  Pending: 'pending'
};
export const AppStateEvent = {
  Change: type => `${type}Change`
};
export const PARTY_TOWN_GLOBAL_FLIPPER_NAME = 'global-tps-proxy';
export const IPV6_EXPANDED_GROUP_COUNT = 8;
export const IPV6_EXPANDED_SUB_GROUP_COUNT = 4;
export const LocalStorageChangeEvent = 'LocalStorageChange';
export const APOLLO_ERROR_TYPES = {
  nonBreaking: 'NON_BREAKING_ERROR',
  redirecting: 'REDIRECTING_ERROR',
  breaking: 'BREAKING_ERROR'
};
export const KBB_BRAND = 'KBB';
export const SAVE_ELOT_PATH = {
  base: '/auth-user/saved-listings',
  byBookmarkId: '/auth-user/saved-listing/id',
  subscribeEmail: '/light-user/price-drop'
};